import React, { useEffect, useRef, useState } from 'react';
import { Grid, TextField, Button, IconButton, Typography, Box, Autocomplete, Chip, LinearProgress, CircularProgress } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';
import axios from './../../axios/api';
import TagInput from '../../components/TagInput';
import toast from 'react-hot-toast';
import { PREFIX_URL } from '../../components/Constants';

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

const top100Films = [
    { label: "حسین سعادتمند", year: 1994 },
    { label: "مصطفی راغب", year: 1972 },
    { label: "حسین اسدی", year: 1974 },
];

const CustomTag = ({ option, getTagProps, index }) => (
    <Chip
        variant="outlined"
        label={option}
        {...getTagProps({ index })}
        style={{ backgroundColor: 'black', color: 'white' }}
    />
);

const FormSongs = ({ isEdit = false, refreshData, idEdit = null, handleCloseModal, DataEdit }) => {
    const [selectedAudio, setSelectedAudio] = useState(null);
    const [ISEdit_SingerValue, setISEdit_SingerValue] = useState(isEdit);
    const [ISEdit_CategoriValue, setISEdit_CategoriValue] = useState(isEdit);

    const [audioName, setAudioName] = useState('');
    const [Title, setTitle] = useState('');
    const [fileInputKey, setFileInputKey] = useState(Date.now());
    const [isLoading, setIsLoading] = useState(false);
    const [selectedTagIds, setSelectedTagIds] = useState([]);
    const [tags, setTags] = useState([]);
    const [InitialState, setInitialState] = useState(true);
    const [LoadingButton, setLoadingButton] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);

    const [inputSinger, setInputSinger] = useState('');
    const [LoadingSinger, setLoadingSinger] = useState(false);
    const [selectedSinger, setSelectedSinger] = useState(null);
    const [DataSinger, setDataSinger] = useState([]);


    const [inputCategori, setInputCategori] = useState('');
    const [LoadingCategori, setLoadingCategori] = useState(false);
    const [selectedCategori, setSelectedCategori] = useState(null);
    const [DataCategori, setDataCategori] = useState([]);

    const [errors, setErrors] = useState({ artist_id: '', path: '', title: '', tags: '', categories: '' });
    const abortControllersRef = useRef(new Set());

    useEffect(() => {
        initializeData();
    }, []);
    useEffect(() => {
        if (isEdit) {
            setTitle(DataEdit?.title);
            if (DataEdit?.path) {
                setSelectedAudio(checkAndAddPrefix(DataEdit?.path));
            }
            if (DataEdit?.tags) {
                setTags(DataEdit?.tags)
            }
            setAudioName('Edit');
        }
    }, [isEdit])

    useEffect(() => {
        // Cleanup function to abort ongoing requests on unmount
        return () => {
            abortControllersRef.current.forEach(controller => controller.abort());
        };
    }, []);

    useEffect(() => {
        setIsLoading(true);
        if (ISEdit_CategoriValue && DataCategori.length > 0) {
            setISEdit_CategoriValue(false);
            setSelectedCategori(DataCategori.find(s => s.id === DataEdit?.categories[0]?.id))
        }
        if (ISEdit_SingerValue && DataSinger.length > 0) {
            setISEdit_SingerValue(false);
            setSelectedSinger(DataSinger.find(s => s.id === DataEdit.artist_id))
        }
        setIsLoading(false);

    }, [DataSinger, DataCategori])
    useEffect(() => {
        if (inputSinger != "") {
            GetDataSinger();
        }
    }, [inputSinger]);
    useEffect(() => {
        if (inputCategori != "") {
            GetDataCategori();
        }
    }, [inputCategori]);





    const reseteState = () => {
        setTags([]);
        setTitle('');
        setInputSinger('');
        setSelectedSinger(null);
        setInputCategori('');
        setSelectedCategori(null);
        setSelectedAudio(null);
        setAudioName('');
    }



    const checkAndAddPrefix = (url) => {
        const prefix = PREFIX_URL;
        if (url && url.startsWith('/uploads/')) {
            return `${prefix}${url}`;
        }
        return url;
    };
    const initializeData = async () => {
        setIsLoading(true);
        try {
            await Promise.all([
                GetDataSinger(),
                GetDataCategori()
            ]);
            setInitialState(false);
        } catch (e) {
            console.log('Error initializing data:', e);
        } finally {
            setIsLoading(false);
        }
    };




    const GetDataCategori = async () => {

        const abortController = new AbortController();
        const signal = abortController.signal;
        abortControllersRef.current.add(abortController);


        try {
            setLoadingCategori(true);
            let url = `/admin/category`;
            if (inputCategori) url += `?search=${inputCategori}&parent_id=null&count_limit=5`;
            const res = await axios.get(`${url}`, { signal });
            const DataCat = await res.data?.data;
            setDataCategori(DataCat);

        } catch (e) {
            if (e.name !== 'AbortError') {
                console.log(e.response, 'eeeeeeeee');
            }
        } finally {
            setLoadingCategori(false);
            abortControllersRef.current.delete(abortController);

        }
    };

    const GetDataSinger = async () => {
        const abortController = new AbortController();
        const signal = abortController.signal;
        abortControllersRef.current.add(abortController);

        try {
            setLoadingSinger(true);
            let url = `/admin/artist`;
            if (inputSinger) url += `?search=${inputSinger}&count_limit=5`;
            const res = await axios.get(`${url}`, { signal });
            setDataSinger(res.data?.data?.data);

        } catch (e) {
            if (e.name !== 'AbortError') {
                console.log(e.response, 'eeeeeeeee');
            }
        } finally {
            setLoadingSinger(false);
            abortControllersRef.current.delete(abortController);

        }
    };


    const handleAudioChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedAudio(file);
            setAudioName(file.name);

            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = reader.result; // Base64 string
                console.log(base64String); // Log the Base64 string for testing
            };
            reader.readAsDataURL(file);
        }
        if (errors.path) {
            setErrors((prevErrors) => ({ ...prevErrors, path: '' }));
        }
    };


    const handleRemoveAudio = () => {
        setSelectedAudio(null);
        setAudioName('');
        setFileInputKey(Date.now());  // Update the key to force a re-render
    };

    const handleTitleChange = (event) => {
        setTitle(event.target.value);
        if (errors.title) {
            setErrors((prevErrors) => ({ ...prevErrors, title: '' }));
        };
    }






    const UpdateSong = async () => {
        try {
            const formData = new FormData();

            // Append the data to the FormData object
            formData.append('artist_id', selectedSinger ? selectedSinger?.id : null);
            formData.append('title', Title);
            formData.append('type', "audio");

            if (tags.length > 0) {
                const tagsString = tags.map(item => item.id.toString()).join(',');

                formData.append('tags', (tagsString));
            }
            if (selectedCategori) {
                const categoriesString = selectedCategori.id.toString()
                formData.append('categories', (categoriesString));
            }
            if (selectedAudio && audioName != 'Edit') {
                formData.append('path', selectedAudio);
            }
            setLoadingButton(true);
            const res = await axios.post(`/admin/track/update/${idEdit}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }, onUploadProgress: (progressEvent) => {
                    const { loaded, total } = progressEvent;
                    let percent = Math.floor((loaded * 100) / total);
                    setUploadProgress(percent);
                }
            });
            if (res.status === 200) {
                setUploadProgress(100);  // Set upload progress to 100% on success
            }
            toast.success(res.data?.message);
            refreshData();
            handleCloseModal();
            reseteState();

        } catch (error) {
            setUploadProgress(0);  // Set upload progress to 100% on success

            toast.error(error.response?.data?.message || 'An error occurred');

            if (error.response?.status === 422) {
                setErrors({
                    title: error.response?.data?.data?.title ? error.response.data.data.title[0] : '',
                    artist_id: error.response?.data?.data?.artist_id ? error.response.data.data.artist_id[0] : '',
                    categories: error.response?.data?.data?.categories ? error.response.data.data.categories[0] : '',
                    tags: error.response?.data?.data?.tags ? error.response.data.data.tags[0] : '',
                    path: error.response?.data?.data?.path ? error.response.data.data.path[0] : '',
                });
            }
        } finally {
            setLoadingButton(false);
        }
    };


    const sendSong = async () => {
        const formData = new FormData();

        // Append the data to the FormData object
        formData.append('artist_id', selectedSinger?.id);
        formData.append('title', Title);
        formData.append('type', "audio");

        if (tags.length > 0) {
            const tagsString = tags.map(item => item.id.toString()).join(',');
            formData.append('tags', (tagsString));
        }
        if (selectedCategori) {
            const categoriesString = selectedCategori.id.toString()
            formData.append('categories', (categoriesString));
        }
        if (selectedAudio) {
            formData.append('path', selectedAudio);
        }

        try {
            setLoadingButton(true);

            const res = await axios.post('/admin/track/store', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }, onUploadProgress: (progressEvent) => {
                    const { loaded, total } = progressEvent;
                    let percent = Math.floor((loaded * 100) / total);
                    setUploadProgress(percent);
                }
            });
            if (res.status === 200) {
                setUploadProgress(100);  // Set upload progress to 100% on success
            }
            toast.success(res.data?.message);
            reseteState();

            // Handle success
        } catch (error) {
            toast.error(error.response?.data?.message || 'An error occurred');
            setUploadProgress(0);

            if (error.response?.status === 422) {
                setErrors({
                    title: error.response?.data?.data?.title ? error.response.data.data.title[0] : '',
                    artist_id: error.response?.data?.data?.artist_id ? error.response.data.data.artist_id[0] : '',
                    categories: error.response?.data?.data?.categories ? error.response.data.data.categories[0] : '',
                    tags: error.response?.data?.data?.tags ? error.response.data.data.tags[0] : '',
                    path: error.response?.data?.data?.path ? error.response.data.data.path[0] : '',
                });
            }
        } finally {
            setLoadingButton(false);
        }
    };




    const isBlobOrFile = (obj) => {
        return obj instanceof Blob || obj instanceof File;
    };
    return (
        <div dir="rtl">
            <Grid container spacing={2}>
                {isLoading ?
                    <CircularProgress size={24} color="inherit" /> :
                    <>
                        <Grid item lg={12} md={12} sm={12}>
                            <TextField
                                id="Title"
                                label="عنوان نوحه"
                                placeholder='نهاد پا در فرات ....'
                                type="text"
                                variant="outlined"
                                fullWidth
                                value={Title}
                                onChange={handleTitleChange}
                                error={Boolean(errors.title)}
                                helperText={errors.title}
                            />
                        </Grid>
                        <Grid item lg={6} md={6} sm={12}>
                            <Autocomplete
                                key={ISEdit_SingerValue}

                                options={DataSinger}
                                getOptionLabel={(option) => (option.name && option.family) ? `${option.name} ${option.family}` : ''}
                                onInputChange={(event, newInputValue) => {
                                    setInputSinger(newInputValue);
                                    if (errors.artist_id) {
                                        setErrors((prevErrors) => ({ ...prevErrors, artist_id: '' }));
                                    }
                                }}
                                onChange={(event, newValue) => {
                                    setSelectedSinger(newValue ? newValue : null);

                                }}
                                renderInput={(params) => (
                                    <TextField
                                        key={ISEdit_SingerValue}

                                        {...params}
                                        label="نام مداح"
                                        variant="outlined"
                                        placeholder="حسین سعادتمند و ..."
                                        fullWidth
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                                <>
                                                    {LoadingSinger ? <CircularProgress color="inherit" size={20} /> : null}
                                                    {params.InputProps.endAdornment}
                                                </>
                                            ),
                                        }}
                                        error={Boolean(errors.artist_id)}
                                        helperText={errors.artist_id}
                                    />
                                )}
                                ListboxProps={{ style: { direction: 'rtl', textAlign: 'right' } }} // Ensures the list is RTL
                                loading={LoadingSinger}
                                loadingText={
                                    <span style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <span style={{ direction: 'rtl', textAlign: 'right', width: '100%' }}>
                                            در حال جستجو...
                                        </span>
                                    </span>
                                }
                                noOptionsText={
                                    <span style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <span style={{ direction: 'rtl', textAlign: 'right', width: '100%' }}>
                                            هیچ مداحی یافت نشد
                                        </span>
                                    </span>
                                }
                                value={selectedSinger}

                            />
                        </Grid>
                        <Grid item lg={6} md={6} sm={12}>
                            <Autocomplete
                                key={ISEdit_CategoriValue}
                                options={DataCategori}
                                getOptionLabel={(option) => option.title || ''}
                                onInputChange={(event, newInputValue) => {
                                    setInputCategori(newInputValue);
                                    if (errors.categories) {
                                        setErrors((prevErrors) => ({ ...prevErrors, categories: '' }));
                                    }
                                }}
                                onChange={(event, newValue) => {
                                    setSelectedCategori(newValue ? newValue : null);

                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        key={ISEdit_CategoriValue}

                                        label="دسته بندی"
                                        variant="outlined"
                                        placeholder="هیئت های یزد و..."
                                        fullWidth
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                                <>
                                                    {LoadingCategori ? <CircularProgress color="inherit" size={20} /> : null}
                                                    {params.InputProps.endAdornment}
                                                </>
                                            ),
                                        }}
                                        error={Boolean(errors.categories)}
                                        helperText={errors.categories}
                                    />
                                )}
                                ListboxProps={{ style: { direction: 'rtl', textAlign: 'right' } }} // Ensures the list is RTL
                                loading={LoadingCategori}
                                loadingText={
                                    <span style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <span style={{ direction: 'rtl', textAlign: 'right', width: '100%' }}>
                                            در حال جستجو...
                                        </span>
                                    </span>
                                }
                                noOptionsText={
                                    <span style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <span style={{ direction: 'rtl', textAlign: 'right', width: '100%' }}>
                                            هیچ دسته بندی یافت نشد
                                        </span>
                                    </span>
                                }
                                value={selectedCategori}

                            />
                        </Grid>

                        <Grid item lg={12} md={12} sm={12}>

                            <TagInput
                                label="تگ ها"
                                placeholder='محرم 1403 ، عاشورا و ...'
                                fetchTagsUrl="/admin/tag"
                                addTagUrl="/admin/tag/store"
                                tagKey="title"
                                setTags={setTags}
                                tags={tags}
                                renderTag={(option, getTagProps, index) => (
                                    <CustomTag option={option} getTagProps={getTagProps} index={index} />
                                )}
                                setErrors={setErrors}
                                errors={errors}
                                error={Boolean(errors.categories)}
                                helperText={errors.categories}
                            />
                        </Grid>

                        <Grid item lg={12} md={12} sm={12}>
                            <Button
                                component="label"
                                role={undefined}
                                variant="contained"
                                tabIndex={-1}
                                startIcon={<CloudUploadIcon />}
                            >
                                <Typography variant="caption">آپلود صوت</Typography>
                                <VisuallyHiddenInput
                                    key={fileInputKey}  // Add a key to force re-render
                                    type="file"
                                    accept="audio/*"
                                    onChange={handleAudioChange}
                                />
                            </Button>
                            {errors.path && (
                                <Typography variant="caption" color="error">
                                    {errors.path}
                                </Typography>
                            )}
                        </Grid>
                        {selectedAudio && (
                            <Grid item lg={12} md={12} sm={12}>
                                <Box sx={{
                                    position: 'relative',
                                    display: 'inline-block',
                                    border: '1px dashed #ccc',
                                    padding: 1,
                                    borderRadius: 2
                                }}>
                                    <audio controls>
                                        <source
                                            // src={URL.createObjectURL(selectedAudio)} 
                                            src={isBlobOrFile(selectedAudio) ? URL.createObjectURL(selectedAudio) : selectedAudio}
                                            type={selectedAudio.type} />
                                        <Typography variant="caption" sx={{ mt: 1 }}>
                                            مرورگر شما از صدا پشتیبانی نمی کند.
                                        </Typography>
                                    </audio>
                                    <IconButton
                                        onClick={handleRemoveAudio}
                                        aria-label="Remove Audio"
                                        size="small"
                                        sx={{
                                            width: 20,
                                            height: 20,
                                            position: 'absolute',
                                            top: -5,
                                            right: -7,
                                            backgroundColor: '#EC2327',
                                            color: 'white',
                                            '&:hover': {
                                                opacity: 1,
                                            },
                                        }}
                                    >
                                        <CloseIcon sx={{ width: 10, height: 10 }} color="black" fontSize="small" />
                                    </IconButton>
                                    <br />
                                    <Typography variant="caption">
                                        {audioName}
                                    </Typography>
                                </Box>
                            </Grid>
                        )}

                        <Grid item lg={12} md={12} sm={12}>
                            {uploadProgress > 0 && uploadProgress != 100 && (
                                <Box sx={{ width: '100%', mb: 2 }}>
                                    <LinearProgress variant="determinate" value={uploadProgress} />
                                    <Typography variant="caption" sx={{ textAlign: 'center' }}>
                                        {uploadProgress}%
                                    </Typography>
                                </Box>
                            )}
                        </Grid>

                        <Grid item lg={12} md={12} sm={12}>
                            {isEdit ?
                                <Button
                                    onClick={UpdateSong}
                                    disabled={LoadingButton}

                                    color="secondary" fullWidth variant="contained" size="large">
                                    {LoadingButton && <CircularProgress size={24} color="inherit" />}


                                    <Typography color="white">ویرایش نوحه</Typography>
                                </Button>
                                :
                                <Button color="secondary" fullWidth variant="contained" size="large"
                                    onClick={sendSong}
                                    disabled={LoadingButton}
                                >
                                    {LoadingButton && <CircularProgress size={24} color="inherit" />}

                                    <Typography color="white">ثبت نوحه جدید</Typography>
                                </Button>
                            }
                        </Grid>
                    </>
                }
            </Grid>
        </div>
    );
};

export default FormSongs;
